import {
    type FC
} from "react";
import {
    View
} from "react-native";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useCodeViewerContext
} from "../../context";
import type {
    ICodeViewerFooterProps
} from "../../type";
import stylesheet, {
    getCodeFooterStyle
} from "../../stylesheet";
import Text from "../../../text";

const CodeViewerFooter: FC<ICodeViewerFooterProps> = ({
    children,
    style,
    title,
    ...props
}) => {
    const context = useCodeViewerContext({
        part: "footer"
    });

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(context?.customTheme);

    if(!context) {
        return null;
    }

    const renderTitle = () => {
        if(!title) {
            return null;
        }

        return <Text
            customTheme={context.customTheme}
            style={stylesheet.footerTitle}
            variant="bodySmallSize"
            color="mid"
        >
            {title}
        </Text>;
    };

    const renderActions = () => {
        if(!children) {
            return null;
        }

        return <View
            style={[
                stylesheet.footerActions,
                {
                    gap: spaces.spacingSm
                }
            ]}
        >
            {children}
        </View>;
    };

    return <View
        {...props}
        style={[
            style,
            stylesheet.footer,
            getCodeFooterStyle({
                borderRadius: context.borderRadius,
                size: context.size,
                type: context.type,
                controlPaddings,
                controlHeights,
                shapeConfigs,
                borders,
                colors,
                spaces
            })
        ]}
    >
        {renderTitle()}
        {renderActions()}
    </View>;
};
export default Object.assign(CodeViewerFooter, {
    codeViewerPart: "footer" as const
});
